import {CONSULTANT_PHONE_NATIONAL} from "@pg-rp/consultants";

export const HOTLINE_INFO_PHONE_NUMBER = CONSULTANT_PHONE_NATIONAL;
export const HOTLINE_VENDOR_REPORT_PHONE_NUMBER = "48 739106355";
import {CONSULTANT_PHONE_NATIONAL} from "@pg-rp/consultants";

export const HOTLINE_INFO_PHONE_NUMBER = CONSULTANT_PHONE_NATIONAL;
export const HOTLINE_VENDOR_REPORT_PHONE_NUMBER = "48 739106355";
